import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import React from 'react';

import { Icon } from '../../../../../../components/Icon';
import { colors } from '../../../../../../styles/tokens';
import {
  Container,
  Empty,
  Header,
  IconBadge,
  Item,
  ItemText,
  ItemTime,
  List,
  Title,
} from './styles';

interface IRecentActivityItem {
  type: 'new_user' | 'training_completed';
  user_fullname: string;
  training_label?: string;
  occurred_at: string | Date;
}

interface RecentActivityProps {
  activities: IRecentActivityItem[];
}

const activityIcon: Record<IRecentActivityItem['type'], string> = {
  new_user: 'person_add',
  training_completed: 'check_circle',
};

const activityIconColor: Record<IRecentActivityItem['type'], string> = {
  new_user: colors.secondary,
  training_completed: colors.onSurfaceVariant,
};

const buildMessage = (activity: IRecentActivityItem): React.ReactNode => {
  if (activity.type === 'new_user') {
    return (
      <>
        <strong>{activity.user_fullname}</strong>{' '}
        <span>se cadastrou na academia</span>
      </>
    );
  }

  return (
    <>
      <strong>{activity.user_fullname}</strong>{' '}
      <span>completou {activity.training_label || 'um treino'}</span>
    </>
  );
};

const RecentActivity: React.FC<RecentActivityProps> = ({ activities }) => {
  return (
    <Container>
      <Header>
        <Title>Atividade Recente</Title>
      </Header>

      {!activities.length && <Empty>Nenhuma atividade recente.</Empty>}

      <List>
        {activities.map((activity, index) => (
          <Item
            // eslint-disable-next-line react/no-array-index-key
            key={`${activity.type}-${activity.user_fullname}-${index}`}
          >
            <IconBadge>
              <Icon
                name={activityIcon[activity.type]}
                size={18}
                color={activityIconColor[activity.type]}
              />
            </IconBadge>
            <div>
              <ItemText>{buildMessage(activity)}</ItemText>
              <ItemTime>
                há{' '}
                {formatDistanceToNow(new Date(activity.occurred_at), {
                  locale: ptBR,
                })}
              </ItemTime>
            </div>
          </Item>
        ))}
      </List>
    </Container>
  );
};

export { RecentActivity };
